import type { TOC } from '@ember/component/template-only';

interface MetricDetailsExploreDataAnomalyDetectionAnomalyDetectedIconComponentInterface {
	Element: HTMLDivElement;
	Args: object;
}

const MetricDetailsExploreDataAnomalyDetectionAnomalyDetectedIconComponent: TOC<MetricDetailsExploreDataAnomalyDetectionAnomalyDetectedIconComponentInterface> =
	<template>
		{{! template-lint-disable no-inline-styles}}
		<svg style="position:absolute" xmlns="http://www.w3.org/2000/svg">
			{{! template-lint-disable no-forbidden-elements}}
			<style>
				:root {
					--anomaly-bg: var(--databox-white-0);
					--anomaly-exclamation-mark: var(--databox-green-500);
					--anomaly-color: var(--databox-green-500);
				}
			</style>
			<symbol width="26" height="40" viewBox="0 0 26 40" id="inline-svg--anomaly-icon">
				{{! template-lint-disable no-forbidden-elements}}
				<style>
					#inline-svg--anomaly-icon .exclamation-mark {
						stroke: var(--anomaly-exclamation-mark);
					}

					#inline-svg--anomaly-icon .base {
						stroke: var(--anomaly-color);
						fill: var(--anomaly-bg);
					}

					#inline-svg--anomaly-icon .line {
						stroke: var(--anomaly-color);
					}

					#inline-svg--anomaly-icon .dot {
						fill: var(--anomaly-color);
					}
				</style>
				<g>
					<path
						d="M1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13Z"
						class="base"
						stroke-width="2"
					/>
					<path d="M13 25V33" class="line" stroke-width="2" stroke-linecap="round" />
					<path
						d="M13 7V15"
						class="exclamation-mark"
						stroke-width="2"
						stroke-linecap="round"
					/>
					<circle cx="13" cy="19" r="0.5" class="exclamation-mark" />
				</g>
			</symbol>
		</svg>
	</template>;

export default MetricDetailsExploreDataAnomalyDetectionAnomalyDetectedIconComponent;
